<template>
  <div>
    <div class="filter-tools">
      <el-input placeholder="请输入关键词" v-model="query" class="query-input">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleQuery"
        ></el-button>
      </el-input>
      <div class="date-locator">
        <span class="date-locator__label">快速定位</span>
        <el-radio-group
          v-model="dateLocator"
          size="small"
          @change="handleDateLocatorChange"
        >
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="yesterday">昨天</el-radio-button>
          <el-radio-button label="beforeYesterday">前天</el-radio-button>
          <el-radio-button label="custom">从日期开始</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-if="dateLocator === 'custom'"
          v-model="customStartDate"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期"
          class="date-locator__picker"
          @change="handleCustomStartDateChange"
        ></el-date-picker>
      </div>
    </div>
    <el-table ref="eventTable" :data="tableData" style="width: 100%">
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="_id" label="赛事ID" width="170">
        <template slot-scope="scope">
          <copy-text :value="scope.row._id"></copy-text>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="比赛名称" min-width="330">
        <template slot-scope="scope">
          <copy-text :value="scope.row.name"></copy-text>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="比赛地点" min-width="140">
      </el-table-column>
      <el-table-column label="比赛时间" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.fuzzyTime">{{ scope.row.fuzzyTime }}</span>
          <span v-else>
            {{ $dayjs(scope.row.startTime).format("YYYY-MM-DD") }} -
            {{ $dayjs(scope.row.endTime).format("YYYY-MM-DD") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="canRecommendEvent" prop="isRecommend" label="是否推荐" width="80">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecommend"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleRecommendStatusChange(scope.row._id)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column v-if="canViewPriority" prop="priority" label="权重" width="80" />
      <el-table-column v-if="canDeleteEvent" prop="isDelete" label="已删除" width="80">
        <template slot-scope="scope">
          <span style="color: red;">{{ scope.row.isDelete ? '已删除' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="hasRowActions" label="操作" :width="operationColumnWidth">
        <template slot-scope="scope">
          <el-button
            v-if="canUpdateEvent"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
          ></el-button>
          <el-button
            v-if="canDeleteEvent"
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.row._id)"
          ></el-button>
          <el-button
            v-if="canRecommendEvent"
            type="primary"
            icon="el-icon-sort"
            @click="setPriority(scope.row._id)"
            >调整优先级</el-button
          >
          <el-button
            v-if="canCopyEvent"
            type="success"
            @click="copy(scope.row)"
            >复制</el-button
          >
          <el-button
            v-if="scope.row.enableRegister && !scope.row.configId && canUpdateRegistrationForm"
            type="primary"
            icon="el-icon-edit-outline"
            @click="editForm(scope.row)"
            >修改报名表单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      class="pager"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page="pageNum"
      @current-change="onCurrentPageChange"
    >
    </el-pagination>
    <edit-dialog
      :editDialogVisible="editDialogVisible"
      :formObj="formObj"
      @edit-success="refreshList"
      @close="dialogClose"
      type="edit"
    ></edit-dialog>

    <!-- 修改报名表单对话框 -->
    <form-define-edit-dialog
      :visible.sync="formEditDialogVisible"
      :eventId="currentEventId"
      @success="handleFormEditSuccess"
    ></form-define-edit-dialog>
  </div>
</template>

<script>
import EditDialog from "../eventManage/components/editDialog.vue";
import FormDefineEditDialog from "../eventManage/components/formDefineEditDialog";
import _ from "loadsh";
import { hasPermission } from "../../utils/auth";
import { confirmLinkEventUsers, getEventIdFromResponse } from "@/utils/eventUserAssociation";

export default {
  components: {
    EditDialog,
    FormDefineEditDialog
  },
  data() {
    return {
      editDialogVisible: false,
      tableData: [],
      formObj: {},
      query: "",
      total: 0,
      pageNum: 1,
      pageSize: 10,
      dateLocator: "all",
      customStartDate: "",
      formEditDialogVisible: false,
      currentEventId: ''
    };
  },
  created() {
    this.getEvents();
  },
  computed: {
    canUpdateEvent() {
      return hasPermission('event:update');
    },
    canDeleteEvent() {
      return hasPermission('event:delete');
    },
    canRecommendEvent() {
      return hasPermission('event:recommend');
    },
    canViewPriority() {
      return hasPermission('event:priority:view');
    },
    canCopyEvent() {
      return hasPermission('event:copy');
    },
    canUpdateRegistrationForm() {
      return hasPermission('registrationForm:update');
    },
    hasRowActions() {
      return this.canUpdateEvent ||
        this.canDeleteEvent ||
        this.canRecommendEvent ||
        this.canCopyEvent ||
        this.canUpdateRegistrationForm;
    },
    operationColumnWidth() {
      let width = 24;
      if (this.canUpdateEvent) width += 48;
      if (this.canDeleteEvent) width += 48;
      if (this.canRecommendEvent) width += 126;
      if (this.canCopyEvent) width += 72;
      if (this.canUpdateRegistrationForm) width += 226;
      return Math.min(Math.max(width, 140), 1060);
    }
  },
  mounted() {
    this.refreshTableLayout();
  },
  watch: {
    query(newVal) {
      if (!newVal) {
        this.pageNum = 1
        this.getEvents()
      }
    }
  },
  methods: {
    onCurrentPageChange(index) {
      this.pageNum = index
      if (this.query) {
        this.handleQuery()
      } else {
        this.getEvents()
      }
    },
    getLocatorStartDate() {
      if (this.dateLocator === "yesterday") {
        return this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
      }
      if (this.dateLocator === "beforeYesterday") {
        return this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
      }
      if (this.dateLocator === "custom") {
        return this.customStartDate;
      }
      return "";
    },
    buildListParams() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        isAll: true
      };
      const startDate = this.getLocatorStartDate();
      if (startDate) params.startDate = startDate;
      return params;
    },
    refreshByCurrentFilter() {
      this.pageNum = 1;
      if (this.query) {
        this.handleQuery();
      } else {
        this.getEvents();
      }
    },
    handleDateLocatorChange(value) {
      if (value !== "custom") {
        this.customStartDate = "";
        this.refreshByCurrentFilter();
      }
    },
    handleCustomStartDateChange() {
      this.refreshByCurrentFilter();
    },
    refreshList() {
      if (this.query) {
        this.handleQuery()
      } else {
        this.getEvents()
      }
    },
    getEvents() {
      this.$axios
        .get("/admin_find_all", {
          params: this.buildListParams(),
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          this.tableData = _.get(res, 'data.res.list')
          this.total = _.get(res, 'data.res.total')
          const output = _.cloneDeep(this.tableData)
          output.forEach((item) => {
            item.startTime = this.$dayjs(item.startTime).format("YYYY-MM-DD")
            item.endTime = this.$dayjs(item.endTime).format("YYYY-MM-DD")
          })
          console.log(output)
          this.refreshTableLayout()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(row) {
      let tempData = _.cloneDeep(row);
      // 处理数组
      tempData.time = [];
      tempData.time.push(tempData.startTime, tempData.endTime);
      tempData.tagStr = tempData.tags.join(",");
      this.formObj = tempData;
      this.editDialogVisible = true;
    },
    handleDelete(_id) {
      this.$confirm("此操作将永久删除该赛事, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.requestDelete(_id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    requestDelete(_id) {
      this.$axios
        .delete(`/del/${_id}`, {
          headers: {
            "x-auth-token": localStorage.getItem("bde_token"),
          },
        })
        .then((res) => {
          if (res.data.code === "success") {
            this.$message.success("删除成功");
            this.refreshList();
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
          if(err.response.data.code === 'token_timeout') {
            this.$router.push('/login')
          }
        });
    },
    dialogClose() {
      this.editDialogVisible = false;
    },
    setPriority(id) {
      this.$prompt("请输入优先级", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[1-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(({ value }) => {
          this.$axios
            .post(
              "/set_priority",
              JSON.stringify({ priority: value, _id: id }),
              {
                headers: {
                  "x-auth-token": localStorage.getItem("bde_token"),
                },
              }
            )
            .then((res) => {
              if (res.data.code === "success") {
                this.$message.success("操作成功！");
              } else {
                this.$message.error("请求失败！");
              }
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
              if(err.response.data.code === 'token_timeout') {
                this.$router.push('/login')
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleQuery() {
      if (!this.query) return this.$message.error("请输入关键字！");
      this.$axios
        .post("/admin_query_by_keyword", {
          name: this.query,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startDate: this.getLocatorStartDate()
        })
        .then((res) => {
          this.tableData = res.data.res.list || [];
          this.total = res.data.res.total || 0;
          this.refreshTableLayout();
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
          console.log(err);
        });
    },
    handleRecommendStatusChange(id) {
      this.$axios
        .post(
          "/change_recommend_status",
          { _id: id },
          {
            headers: {
              "x-auth-token": localStorage.getItem("bde_token"),
            }
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code === "success") {
            this.$message.success("操作成功！");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
          console.log(err);
          if(err.response.data.code === 'token_timeout') {
            this.$router.push('/login')
          }
        });
    },
    copy(row) {
      const obj = _.cloneDeep(row)
      delete obj._id
      delete obj.__v
      obj.isConfigId = false
      // configId 保留原值（复用同一个表单配置）
      // 没有 configId 的赛事，复制后没有自己的 FormDefine，enableRegister 应为 false
      if (!obj.configId) {
        obj.enableRegister = false
      }
      this.$confirm("确定复制该赛事?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
          .post('/copy_event', JSON.stringify(obj), {
            headers: {
              "x-auth-token": localStorage.getItem("bde_token"),
            },
          })
          .then(async (res) => {
            if (res.data.code === "success") {
              this.$message.success("操作成功！");
              await confirmLinkEventUsers(this, {
                eventId: getEventIdFromResponse(res),
                eventName: obj.name
              });
              this.refreshList();
            } else {
              this.$message.error("请求错误！");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.response.data.message);
            if (err.response.data.code === "token_timeout") {
              this.$message.error("登录过期，请重新登录！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复制",
          });
        });
    },
    editForm(row) {
      if (!this.canUpdateRegistrationForm) {
        this.$message.error('无修改报名表单权限');
        return;
      }
      // 判断是否有配置文件ID
      if (row.configId) {
        this.$message.warning('该赛事已开启配置文件，请前往修改赛事配置文件对应的赛事表单');
        return;
      }

      // 设置当前赛事ID并打开对话框
      this.currentEventId = row.formDefineId || row._id;
      this.formEditDialogVisible = true;
    },
    handleFormEditSuccess() {
      this.refreshList();
    },
    refreshTableLayout() {
      this.$nextTick(() => {
        if (this.$refs.eventTable && this.$refs.eventTable.doLayout) {
          this.$refs.eventTable.doLayout();
        }
      });
    }
  },
};
</script>

<style scoped>
.query-input {
  width: 30%;
  min-width: 260px;
}
.filter-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 40px;
}
.date-locator {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.date-locator__label {
  color: var(--text-regular, #606266);
  font-size: 14px;
}
.date-locator__picker {
  width: 150px;
}
.pager {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .date-locator {
    width: 100%;
    align-items: flex-start;
    gap: 8px;
  }

  .date-locator__label {
    width: 100%;
    line-height: 1.4;
  }

  .date-locator /deep/ .el-radio-group {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }

  .date-locator /deep/ .el-radio-button,
  .date-locator /deep/ .el-radio-button__inner {
    display: block;
    width: 100%;
  }

  .date-locator /deep/ .el-radio-button__inner {
    border-left: 1px solid var(--border-base, #dcdfe6);
    border-radius: 4px;
    padding: 9px 8px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .date-locator /deep/ .el-radio-button:first-child .el-radio-button__inner,
  .date-locator /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 4px;
  }

  .date-locator__picker {
    width: 100%;
  }
}
</style>
